import './GetInTouch.css'
import { Link } from 'react-router-dom'
import { FaLocationDot } from "react-icons/fa6";

const GetInTouch = () => {
  return (
    <div>
      <div className="getin">
        <div className='getintouch'>
          <div className="getintouch-left" data-aos="fade-up"
            data-aos-duration="1000">
            <div className="getintouch-left-heading">
              <h3 >GET IN TOUCH</h3>
              <hr />
            </div>
            <p>We're here to help with any questions you may have. Feel free to reach out to us!</p>
            <div className="getintouch-left-content">
              <div className="getintouch-left-content-adress">
                <h5>VISIT US</h5>
                <p><p className='flex items-start gap-2'><FaLocationDot size={22} className='mt-1' /> 25/26-H, Broadway Commercial, Khayaban-e-Amin, Lahore</p> <br />
                  <p className='flex items-start gap-2'><FaLocationDot size={22} className='mt-1' /> 43 C Springs Meadows, Bahria Town Lahore</p> <br />
                  <p className='flex items-start gap-2'><FaLocationDot size={22} className='mt-1' /> 37–46/CC, Sector-B, Pine Avenue, Khayaban-e-Amin, Lahore</p></p>
              </div>
              <div className="getintouch-left-content-call">
                <h5>CALL US</h5>
                <p>UAN: 0311 1100 564</p>
              </div>
              <div className="getintouch-left-content-email">
                <h5>EMAIL US</h5>
                <Link to="mailto:info@avenueonepk.com">info@avenueonepk.com</Link>
              </div>
              <div className="getintouch-left-content-follow">
                <h5>FOLLOW US</h5>
                <div className='getintouch-left-content-follow-links'>
                  <Link to='https://www.instagram.com/theavenueonepk?stkn=MWhwbTNrYXh0OW5jbg==' target='_blank' className='getintouch-left-content-follow-links-fb'>
                    <img src="./ContactPhotos/GetIn/fb.png" alt="" className='getintouch-left-content-email-links-img-fb' />
                  </Link>
                  <Link to='https://www.facebook.com/share/1K8GrR9vjj/' target='_blank' className='getintouch-left-content-follow-links-insta'>
                    <img src="./ContactPhotos/GetIn/insta.png" alt="" className='getintouch-left-content-email-links-img-insta' />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="getintouch-right" data-aos="fade-up"
            data-aos-duration="1000">
            <form action="" className="getintouch-right-form">
              <div className='getintouch-right-form'>
                <label htmlFor="name">Name <sup>*</sup></label>
                <div>
                  <input type="text" name="" id="name" placeholder='First Name' />
                  <input type="text" name="" id="" placeholder='Last Name' />
                </div>
              </div>
              <div className="w-full flex flex-col pt-4">
                <label htmlFor="phone">
                  Phone Number <sup>*</sup>
                </label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder="03XX XXXXXXX"
                  required
                  className="w-full h-[45px] px-[25px] border-none rounded-[2px] bg-white text-[#222] text-[15px] focus:outline-none"
                />
              </div>
              <label htmlFor="mail">Email</label>
              <input type="text" name="" id="mail" placeholder='xyz@gmail.com' />
              <label htmlFor="msg">Comment or Message <sup>*</sup></label>
              <textarea name="" id="msg" cols="30" rows="5" style={{ lineHeight: "20px" }}></textarea>
              <input type="submit" value="Send Message" />
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetInTouch